import React from 'react';
import type { TableInstance } from 'react-table';
import Box from '../Box';
import Table, { TableCell, TableHeader, TableHeaders, TableRow } from './Table';

const SimpleReactTable = <T extends object>({
  table,
  layout,
}: {
  table: TableInstance<T>;
  layout?: 'auto' | 'fixed';
}) => {
  const { getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } =
    table;

  return (
    <Box borderColor="neutral.gray_225" borderWidth={1} borderStyle="solid">
      <Table
        data-testid={'table ' + headerGroups[0].headers[0].render('Header')}
        layout={layout}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            // eslint-disable-next-line react/jsx-key
            <TableHeaders isSticky {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // eslint-disable-next-line react/jsx-key
                <TableHeader
                  {...column.getHeaderProps()}
                  width={column.columnWidth}
                >
                  {column.render('Header')}
                </TableHeader>
              ))}
            </TableHeaders>
          ))}
        </thead>
        <tbody {...getTableBodyProps}>
          {rows.map((row, index) => {
            prepareRow(row);
            const { key, ...rowProps } = row.getRowProps();

            return (
              <TableRow
                data-testid={'row ' + index}
                key={key}
                isMuted={index % 2 !== 0}
                {...rowProps}
              >
                {row.cells.map((cell) => {
                  const { key, ...cellProps } = cell.getCellProps();
                  return (
                    <TableCell
                      data-testid={cell.column.render('Header')}
                      key={key}
                      {...cellProps}
                    >
                      {cell.render('Cell')}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </tbody>
        <tfoot>
          {footerGroups.map((group) => (
            // eslint-disable-next-line react/jsx-key
            <TableRow {...group.getFooterGroupProps()}>
              {group.headers.map((column) => (
                // eslint-disable-next-line react/jsx-key
                <TableCell
                  data-testid={'Total ' + column.render('Header')}
                  {...column.getFooterProps()}
                >
                  {column.render('Footer')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </tfoot>
      </Table>
    </Box>
  );
};

export default SimpleReactTable;
